import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContractComponent } from './pages/contract/contract.component';
import { CrewEditComponent } from './pages/crew-edit/crew-edit.component';
import { EquipmentEditComponent } from './pages/equipment-edit/equipment-edit.component';
import { TimesheetComponent } from './pages/timesheet/timesheet.component';

const routes: Routes = [
  { path: 'contract', component: ContractComponent },
  { path: 'timesheet', component: TimesheetComponent, title: 'Timesheet' },
  { path: 'crew/labor', component: CrewEditComponent, title: 'Timesheet > Employees' },
  { path: 'crew/equipment', component: EquipmentEditComponent, title: 'Timesheet > Equipment' },
  { path: '**', redirectTo: 'contract' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- This rule is OK to disable here since a class is required and we don't have to do anything with it
export class AppRoutingModule {}
